import { useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import dbService from "../../services/database";
import { auth } from "../../firebase";
import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import UserHistory from "../../components/UserHistory/UserHistory";
import { Link } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { FaUser, FaMoneyBillWave, FaUsers } from "react-icons/fa";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const Single = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true); // Add this for the loading state

  const fetchUser = useCallback(async () => {
    try {
      const userData = await dbService.getUserById(userId);

      if (userData) {
        // Map PostgreSQL fields to expected format
        const mappedUser = {
          ...userData,
          displayName: userData.display_name,
          membershipCode: userData.membership_code,
          imageUrl: userData.img_url || userData.img,
          card: userData.ghana_card,
          channel: userData.payment_channel,
          share: userData.share_amount,
          price: userData.share_value,
          code: userData.branch_code,
          kin: userData.next_of_kin,
        };

        setUser(mappedUser);
      } else {
        console.log("No such user!");
      }

      // Fetch attendance history with auth token
      try {
        const token = auth.currentUser
          ? await auth.currentUser.getIdToken(true)
          : null;
        const headers = {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        };
        const attendanceResponse = await fetch(
          `${API_BASE_URL}/attendance/${userId}`,
          { headers },
        );
        if (attendanceResponse.ok) {
          const attendanceData = await attendanceResponse.json();
          setAttendance(attendanceData.data || []);
        }
      } catch (attendanceErr) {
        console.log("Error fetching attendance:", attendanceErr);
      }
    } catch (err) {
      console.log("Error getting user:", err);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  if (loading) {
    // Display the BeatLoader while loading
    return (
      <div className="loaderContainer">
        <BeatLoader color="#7451f8" />
        <p>Loading...</p>
      </div>
    );
  }
  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="userInfoWrapper">
          <div className="userHeader">
            <div className="headerLeft">
              <img
                src={user?.imageUrl || "/assets/default-avatar.png"}
                alt=""
                className="userAvatar"
              />
              <div className="userBasicInfo">
                <h1>{user?.displayName}</h1>
                <span className="membershipId">ID: {user?.membershipCode}</span>
              </div>
            </div>
            <div className="headerActions">
              <Link to={`/certificates`} className="secondaryButton">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                Certificates
              </Link>
              <Link to={`/users/edit/${userId}`} className="editButton">
                Edit Profile
              </Link>
            </div>
          </div>

          <div className="infoGrid">
            <div className="infoCard">
              <div className="cardHeader">
                <FaUser className="icon" />
                <h3>Personal Information</h3>
              </div>
              <div className="cardContent">
                <div className="infoItem">
                  <span className="label">Email</span>
                  <span className="value">{user?.email}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Phone</span>
                  <span className="value">{user?.phone}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Address</span>
                  <span className="value">{user?.address}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Ghana Card</span>
                  <span className="value">{user?.card}</span>
                </div>
              </div>
            </div>

            <div className="infoCard">
              <div className="cardHeader">
                <FaMoneyBillWave className="icon" />
                <h3>Financial Information</h3>
              </div>
              <div className="cardContent">
                <div className="infoItem">
                  <span className="label">Account Number</span>
                  <span className="value">{user?.account}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Payment Channel</span>
                  <span className="value">{user?.channel}</span>
                </div>
                <div className="infoItem highlight">
                  <span className="label">Number of Shares</span>
                  <span className="value">{user?.share}</span>
                </div>
                <div className="infoItem highlight">
                  <span className="label">Share Value</span>
                  <span className="value">GH₵ {user?.price}</span>
                </div>
              </div>
            </div>

            <div className="infoCard">
              <div className="cardHeader">
                <FaUsers className="icon" />
                <h3>Additional Information</h3>
              </div>
              <div className="cardContent">
                {/* <div className="infoItem">
                  <span className="label">Branch Code</span>
                  <span className="value">{user?.code}</span>
                </div> */}
                <div className="infoItem">
                  <span className="label">Next of Kin</span>
                  <span className="value">{user?.kin}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Membership Code</span>
                  <span className="value">{user?.membership_code}</span>
                </div>
              </div>
            </div>

            <div className="infoCard">
              <div className="cardHeader">
                <FaUsers className="icon" />
                <h3>AGM Attendance History</h3>
              </div>
              <div className="cardContent">
                {attendance.length > 0 ? (
                  <div className="attendanceList">
                    {attendance.map((record) => (
                      <div key={record.id} className="infoItem">
                        <span className="label">{record.year} AGM</span>
                        <span className="value">
                          ✅ Attended (
                          {new Date(record.attended_date).toLocaleDateString()})
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="infoItem">
                    <span className="value">No attendance records found</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="transactionHistory">
            <h2>Transaction History</h2>
            <UserHistory userId={userId} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Single;
